import type * as React from 'react';
import { Header } from 'components/header';
import {
  buttons,
  container,
  header,
  headingAndSupportingText,
  paragraph,
  wrapper,
} from './styles.css';

export const Wrapper: React.FC<{
  heading: string;
  description: string;
  buttons?: React.ReactNode;
  icon: React.ReactNode;
  iconPosition?: 'above' | 'below';
}> = ({
  heading,
  description,
  buttons: buttonElements,
  icon,
  iconPosition = 'above',
}) => (
  <>
    <Header />
    <main className={wrapper}>
      <div className={container({ iconPosition })}>
        <div>
          <div className={headingAndSupportingText}>
            <h1 className={header}>{heading}</h1>
            <p className={paragraph}>{description}</p>
          </div>
          {buttonElements ? (
            <div className={buttons}>{buttonElements}</div>
          ) : null}
        </div>
        <div>{icon}</div>
      </div>
    </main>
  </>
);
